import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "filepdf"
const FilepdfIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M5.375 19.125H3.5a.627.627 0 0 1-.625-.625v-15c0-.344.281-.625.625-.625h6.25V6c0 .691.559 1.25 1.25 1.25h3.125v5.625H16v-5.84a2.5 2.5 0 0 0-.73-1.77L11.734 1.73A2.5 2.5 0 0 0 9.964 1H3.5A2.5 2.5 0 0 0 1 3.5v15C1 19.879 2.121 21 3.5 21h1.875zM18.889 15.363V21h1.434v-2.102h2.183v-1.097h-2.183v-1.285h2.402v-1.153z" />
      <path
        fillRule="evenodd"
        d="M13.019 21v-5.637h2.367q.843 0 1.43.325.59.32.898.937t.309 1.496v.008q0 .922-.305 1.566a2.14 2.14 0 0 1-.895.973q-.586.332-1.437.332zm1.433-1.152h.676q.465 0 .781-.192.32-.19.485-.566.168-.38.168-.934v-.008q0-.523-.172-.886a1.2 1.2 0 0 0-.492-.555 1.47 1.47 0 0 0-.77-.191h-.676zM9.098 19.352V21H7.664v-5.637h2.43q.629 0 1.094.25.465.246.718.696.258.445.258 1.05v.008q0 .602-.258 1.051-.254.445-.719.691-.465.243-1.093.243zm0-1.086h.648q.457 0 .711-.23.258-.232.258-.669v-.008q0-.441-.258-.668-.255-.225-.71-.226h-.65z"
        clipRule="evenodd"
      />
    </svg>
  )
}
export default FilepdfIcon
